import { render, staticRenderFns } from "./fileupload.vue?vue&type=template&id=1cf1c560&"
import script from "./fileupload.vue?vue&type=script&lang=js&"
export * from "./fileupload.vue?vue&type=script&lang=js&"
import style0 from "./fileupload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1cf1c560', component.options)
    } else {
      api.reload('1cf1c560', component.options)
    }
    module.hot.accept("./fileupload.vue?vue&type=template&id=1cf1c560&", function () {
      api.rerender('1cf1c560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/components/fileupload.vue"
export default component.exports